<template>
  <header id="topNav" data-ts="TopNav">
    <div class="inner">
      <div class="logo">
        <a href="/support/search">
          <img class="logo-img-icon" src="/images/logo.png" alt="Juvo Logo" />
        </a>
      </div>
      <nav role="navigation" class="topNav">
        <ul class="list-unstyled">
          <li
            v-for="(item, index) in orderedMenu"
            :key="index"
            class="nav-item"
          >
            <!-- Render the menu items here -->
            <a
              :class="{ activeMenuItem: currentLocation === item.href }"
              v-if="!item.sub_menu"
              :href="item.href"
            >
              {{ item.label }}
            </a>

            <!-- Render the sub-menu items here -->
            <a
              style="cursor: default"
              href="#"
              class="sub-nav"
              :class="{
                activeMenuItem: !!item.sub_menu.some(
                  (subItem) => subItem.href === currentLocation
                ),
              }"
              v-if="item.sub_menu"
            >
              {{ item.label }}
            </a>
            <ul class="sub-nav-inner">
              <li v-for="subItem in item.sub_menu" :key="subItem.label">
                <a
                  :class="{ activeMenuItem: currentLocation === subItem.href }"
                  :href="subItem.href"
                >
                  {{ subItem.label }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    menuItems: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentLocation: location.pathname,
    };
  },
  computed: {
    orderedMenu() {
      const items = [...this.menuItems.items];
      return items.sort((a, b) => a.order - b.order);
    },
  },
  mounted() {
    console.log(this.menuItems);
  },
};
</script>

<style scoped>
header {
  position: fixed;
  width: 100%;
  height: 2.5rem;
  background: #222;
  z-index: 100;
}

header.alt-header {
  background: #fff;
}

.alt-header a {
  color: #222;
}

body.header-fixed header {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 2;
}

li {
  list-style: none;
}

.topNav {
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  margin-left: 0.5rem;
  width: 75%;
}

.topNav li {
  display: inline;
  float: left;
}

.topNav a {
  display: inline-block;
  color: #fff;
  text-decoration: none;
  padding: 0.5rem;
  transition: 0.3s all;
}

.topNav a:hover {
  background: #333;
}

.logo {
  color: #fff;
  font-size: 50px;
  line-height: 2.5rem;
  transition: 0.7s all;
}

.alt-header .logo {
  color: #000;
}

body.header-fixed .logo {
  font-size: 30px;
}

.logo,
.topNav,
.user-settings {
  float: left;
}

.logo-img-icon {
  height: 30px;
  margin-left: 0.4rem;
  margin-top: 0.3rem;
  vertical-align: top !important;
}

.inner {
  height: 100%;
}

.inner:after {
  content: '';
  display: table;
  clear: both;
}

.user-settings {
  float: right;
  height: 100%;
  display: inline-block;
  color: white;
}

.sub-nav-inner {
  display: none;
}

.nav-item:hover .sub-nav-inner {
  display: flex;
  flex-direction: column;
  z-index: 999;
  position: absolute;
  background: #222;
}

.sub-nav-inner li a {
  width: 100%;
  position: relative;
}

.sub-nav {
  position: relative;
}

.sub-nav:hover::after {
  content: '';
  position: absolute;
  background: grey;
  height: 2px;
  width: 0;
  bottom: 0;
  left: 0;
  border-radius: 1px;
  animation: grow-width 0.5s ease-in-out forwards;
}

@keyframes grow-width {
  from {
    width: 0;
  }
  to {
    width: 60%;
  }
}
</style>
